import Selector from '@/components/zthd/Selector'

const mediaGroups = [
  {
    value: 'total',
    label: 'Total',
  },
  {
    value: 'app',
    label: 'App',
  },
  {
    value: 'organic',
    label: 'Organic',
  },
  {
    value: 'ads',
    label: 'Ads',
  },
  {
    value: 'ads25',
    label: 'Ads 2.5',
  },
  {
    value: 'ads30',
    label: 'Ads 3.0',
  },
  {
    value: 'meta',
    label: 'Meta',
  },
  {
    value: 'metavo',
    label: 'Meta VO',
  },
  {
    value: 'tiktok',
    label: 'TikTok',
  },
  {
    value: 'unity',
    label: 'Unity',
  },
  {
    value: 'unity30',
    label: 'Unity 3.0',
  },
  {
    value: 'apple',
    label: 'Apple Ads',
  },
]

export const DropdownMediaGroup = ({ value, update }) => {
  return (
    <Selector
      datas={mediaGroups}
      showLabel
      labelName="Media Group"
      value={value}
      update={update}
    />
  )
}
